import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';


const statesOfIndia = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan",
    "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh",
    "West Bengal", "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep", "Delhi", "Puducherry", "Ladakh", "Lakshadweep", "Jammu and Kashmir"
];


const sortedStatesOfIndia = statesOfIndia.sort();



const BannerScheduleModal = ({ isOpen, onClose, onSave, BannerId }) => {
    // const [formData, setFormData] = useState({
    //     date_range: '',
    //     product_category: '1',
    //     applicable_states: [],
    //     bannerId: BannerId,
    // });

    const [formData, setFormData] = useState({
        start_date: '',
        end_date: '',
        product_category: '1',//
        applicable_states: [],//
        bannerId: BannerId,//
        selectAllStates: false,
    });




    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };



    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // onSave(formData);
        // onClose();
        
        try {
            // Call the onSave function and wait for the response
            const response = await onSave(formData);

            // Check if the response status is 201 (Created)
            if (response.StatusCode === 201) {
                // Clear the form data
                setFormData({
                    start_date: '',
                    end_date: '',
                    product_category: '1',
                    applicable_states: [],
                    bannerId: BannerId,
                    selectAllStates: false,
                });

                // Optionally, close the form
                onClose();
            }
        } catch (error) {
            // Handle any errors that occur during the saving process
            console.error("Error during saving:", error);
            // Optionally, handle the error case here (e.g., show a notification or alert)
        }
    };

    const handleStateChange = (e) => {
        const { name, checked } = e.target;

        if (name === "India") {

            setFormData({
                ...formData,
                applicable_states: checked ? sortedStatesOfIndia : [],
                selectAllStates: checked,
            });
        } else {

            const updatedStates = checked
                ? [...formData.applicable_states, name]
                : formData.applicable_states.filter(state => state !== name);

            setFormData({
                ...formData,
                applicable_states: updatedStates,
            });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay-schedule">
            <div className="modal-content-schedule">
                <button className="close-btn-schedule" onClick={onClose}>
                    &times;
                </button>
                <h2>Edit Banner Schedule</h2>
                <form onSubmit={handleSubmit}>

                    <label style={{ marginTop: "12px" }}>
                        Start Date:
                        <input
                            type="date"
                            name="start_date"
                            value={formData.start_date || ''}
                            onChange={handleDateChange}
                            placeholder="dd/mm/yyyy"
                            required
                        />
                    </label>
                    <label style={{ marginTop: "12px" }}>
                        End Date:
                        <input
                            type="date"
                            name="end_date"
                            value={formData.end_date || ''}
                            onChange={handleDateChange}
                            placeholder="dd/mm/yyyy"
                            required
                        />
                    </label>

                    <label style={{ display: "flex", marginTop: "12px", gap: "6px" }}>
                        Product Category:
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <input
                                type="radio"
                                id="general"
                                name="product_category"
                                value="1"
                                checked={formData.product_category === "1"}
                                onChange={handleChange}
                            />
                            <label htmlFor="general">General</label>
                            <input
                                type="radio"
                                id="storewise"
                                name="product_category"
                                value="2"
                                checked={formData.product_category === "2"}
                                onChange={handleChange}
                            />
                            <label htmlFor="storewise">Storewise</label>
                        </div>
                    </label>

                    {formData.product_category === "1" && (

                        <>
                            {/* <label>
                                Select States:
                                <div>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="India"
                                            checked={formData.selectAllStates}
                                            onChange={handleStateChange}
                                        />
                                        India (Select All States)
                                    </label>
                                    <div>

                                        {sortedStatesOfIndia.map((state, index) => (
                                            <label key={index}>
                                                <input
                                                    type="checkbox"
                                                    name={state}
                                                    checked={formData.applicable_states.includes(state)}
                                                    onChange={handleStateChange}
                                                />
                                                {state}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </label> */}

                            {/* <label>
                                Select States:
                                <select
                                    multiple
                                    value={formData.applicable_states}
                                    onChange={handleStateChange}
                                    size={10}
                                >
                                    <option
                                        value="selectAll"
                                        onClick={() => handleStateChange({ target: { name: 'India', value: 'selectAll' } })}
                                    >
                                        India (Select All States)
                                    </option>

                                    {sortedStatesOfIndia.map((state, index) => (
                                        <option key={index} value={state}>
                                            {state}
                                        </option>
                                    ))}
                                </select>
                            </label> */}

                            <div className="dropdown-container-schedule">
                                <label style={{ marginTop: "12px" }}>Select States(Hover Here)</label>
                                <div className="dropdown-schedule">
                                    <div className="dropdown-menu-schedule">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="India"
                                                checked={formData.selectAllStates}
                                                onChange={handleStateChange}
                                            />
                                            India (Select All States)
                                        </label>
                                        {sortedStatesOfIndia.map((state, index) => (
                                            <label key={index}>
                                                <input
                                                    type="checkbox"
                                                    name={state}
                                                    checked={formData.applicable_states.includes(state)}
                                                    onChange={handleStateChange}
                                                />
                                                {state}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div style={{ display: "flex", justifyContent: "center", marginTop: "12px" }}>
                        <button type="submit" className="save-btn-schedule">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BannerScheduleModal;
